import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------customer advance page api's-------------------------------->
    /**
     * customer advance index page api
     * @param {*} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getCustomerAdvances(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customeradvance/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    getCustomerAdvanceExport(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customeradvance/export/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    /**
     * create api 
     * @param {*} form 
     */
    postCustomerAdvance(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customeradvance/create', form)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getCustomerAdvance(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customeradvance/view/' + id)
    },
    /**
     * update list api
     * @param {*} id 
     */
    getCustomerAdvanceView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customeradvance/viewpage/' + id)
    },
    /**
     * update api
     * @param {*} form 
     * @param {*} id 
     */

    postCustomerAdvanceUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customeradvance/update/' + id, form)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getCustomerAdvanceDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customeradvance/singledelete', data)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postCustomerAdvanceRefundUpdate(id, form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customeradvance/refund/' + id, form)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    postCustomerAdvanceRefundDelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customeradvance/refunddelete/' + id)
    },
    /**
     * 
     * @param {*} data 
     */
    postFiltercreateCustomerAdvance(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customeradvance/filtercreate', data)
    },
    /**
     * 
     * @param {*} data 
     * @param {*} id 
     */
    postFilterudpateCustomerAdvance(data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customeradvance/filterupdate/' + id, data)
    },
    /**
     * 
     * @param {*} data 
     */
    postFilterdeleteCustomerAdvance(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customeradvance/filterdelete', data)
    },
    /**
     * bulk delete api 
     */
    postCustomerAdvanceBulkDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customeradvance/bulkdelete', data)
    },

}